import { Link, navigate, useIntl } from 'gatsby-plugin-intl'
import React, { useEffect } from 'react'
import Layout from '../../components/Layout/index'
import PressRelease from '../../components/PressRelease'
import SEO from '../../components/seo'
import Footer from '../../modules/Footer'
import Header from '../../modules/Header'

import Image from '../../images/news/alltours-teaser.png'
import metaDescription from '../../messages/pageMetaDescriptions.lang'
import messages from '../../messages/pageTitles.lang'

import { newsList } from '../../components/NewsPage/data'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  useEffect(() => {
    if (global.window && locale === 'en') {
      navigate('/newsroom/')
    }
  }, [])

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleNewsAlltours)}
        imageAlt={formatMessage(messages.TitleNewsAlltours)}
        description={formatMessage(metaDescription.NewsAlltoursDescription)}
        image={Image}
        nofollow={locale === 'en'}
        lang={locale}
      />
      <PressRelease
        article={newsList.alltours}
        articleLinks={{
          tsbo: <Link to="/products/travelsandbox/">https://www.freshcells.de/de/products/travelsandbox/</Link>,
          fusion: <Link to="/products/fusion/">https://www.freshcells.de/de/products/fusion/ </Link>
        }}
      />
    </Layout>
  )
}

export default IndexPage
